import React from 'react';
import DashboardLayout from '@/components/layout/DashboardLayout';
import SubmDashboard from '@/components/zoho/submissions/SubmDashboard';

export default function ZohoSubmissionsPage() {
  return (
    <DashboardLayout>
      <SubmDashboard />
    </DashboardLayout>
  );
}
